import { render, staticRenderFns } from "./ClaimGuideTab.vue?vue&type=template&id=22ffdd64&scoped=true"
import script from "./ClaimGuideTab.vue?vue&type=script&lang=js"
export * from "./ClaimGuideTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ffdd64",
  null
  
)

export default component.exports